import { useContext } from 'react';

import {
    CurrentUserActionIndicatorContext,
    UserActionIndicatorChangerContext,
} from '../../contexts/user-action-indicator';
import { UserActionIndicatorChangers } from '../../types/user-action-indicator';

export const useCurrentUserActionIndicator = () => useContext(CurrentUserActionIndicatorContext);

export const useUserActionIndicatorChangers = (): UserActionIndicatorChangers => {
    const context = useContext(UserActionIndicatorChangerContext);

    if (!context) {
        throw new Error(
            'useUserActionIndicatorChangers must be used within UserActionIndicatorProvider'
        );
    }

    return context;
};
